/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tool: NonNullable<unknown> }} Options_Cli_Select_Executable_HelpInputs */



/**
* | output |
* | --- |
* | "Select the location of the {tool} executable" |
*
* @param {Options_Cli_Select_Executable_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_cli_select_executable_help = /** @type {((inputs: Options_Cli_Select_Executable_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Cli_Select_Executable_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Sélectionner l'emplacement de l'exécutable ${i?.tool}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Wählen Sie den Speicherort der ausführbaren Datei ${i?.tool} aus.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Seleziona la posizione dell'eseguibile ${i?.tool}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Выберите местоположение исполняемого файла ${i?.tool}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Seleccione la ubicación del ejecutable ${i?.tool}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`选择 ${i?.tool} 可执行文件的位置`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.tool} 実行ファイルの場所を選択します`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.tool} निष्पादन योग्य फ़ाइल का स्थान चुनें`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Selecione a localização do executável ${i?.tool}`)
	return /** @type {LocalizedString} */ (`Select the location of the ${i?.tool} executable`)
});